<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Sąskaitos numeris"
          tooltip="Hipoteka. Turtas. Banko sąskaita. Sąskaitos numeris"
          v-mask="saskaitaMask"
          placeholder="LT## ##### ###########"
          :readonly="turtasReadonly || !sudarymas"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          :need="!isBankasFromSaskaita"
          :readonly="isBankasFromSaskaita || turtasReadonly"
          label="Bankas"
          tooltip="Hipoteka. Turtas. Banko sąskaita. Bankas"
          :counter="250"
          v-model="formData.tur_banko_saskaita_bankas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-money-field
          label="Lėšos banko sąskaitoje"
          tooltip="Hipoteka. Turtas. Banko sąskaita. Lėšos banko sąskaitoje"
          :readonly="turtasReadonly"
          v-model="formData.tur_banko_saskaita_lesos"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          :need="!isBankasFromSaskaita"
          :readonly="isBankasFromSaskaita || turtasReadonly"
          label="Banko kodas"
          v-mask="bankoKodasMask"
          tooltip="Hipoteka. Turtas. Banko sąskaita. Banko kodas"
          v-model="formData.tur_banko_saskaita_banko_kodas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-autocomplete
          :need="needValiuta"
          :items="formData.valiutos"
          itemvalue="value"
          itemtext="text"
          label="Valiuta"
          tooltip="Hipoteka. Turtas. Banko sąskaita. Valiuta"
          :readonly="turtasReadonly"
          v-model="formData.tur_banko_saskaita_valiuta"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasBankoSaskaita',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      //
    }
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
    saskaitaMask() {
      return 'AA## ##### ###########'
    },
    bankoKodasMask() {
      return '##########'
    },
    needValiuta() {
      return this.formData.tur_banko_saskaita_lesos
        ? this.formData.tur_banko_saskaita_lesos != null &&
            this.formData.tur_banko_saskaita_lesos.length > 0
        : false
    },
    saskaitaBankoKodas() {
      return this.formData.tur_identifikatorius
        ? this.formData.tur_identifikatorius.slice(5, 10)
        : ''
    },
    bankasFromSaskaita() {
      return this.formData.bankai
        ? this.formData.bankai.find(bankas => {
            if (bankas.value === this.saskaitaBankoKodas) {
              this.formData.tur_banko_saskaita_bankas = bankas.text
              this.formData.tur_banko_saskaita_banko_kodas = bankas.value
              return true
            }
            return false
          })
        : false
    },
    isBankasFromSaskaita() {
      return this.bankasFromSaskaita != null
    },
  },
  methods: {
    //
  },
}
</script>
